// extracted by mini-css-extract-plugin
export default {"section":"ZVfdFE5kLifB0wirDciQ","title":"_zQtvD8t0Tk4I8dK3Ejp","icon":"t632FBpWOM6EFhMJIDpC","subtitle":"Nvy9r9fE_r_qlqKuuJNd"};